"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-undef */
const runtime_1 = require("@tarojs/runtime");
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
Component(runtime_1.createRecursiveComponentConfig());
//# sourceMappingURL=comp.js.map